import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

export class BreadcrumbToolbarController {
  public static $inject = ['breadcrumbService', '$transitions'];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private $transitions
  ) {
    this.registerStateChangeListener();
  }

  /**
   * Activates a state change listener
   */
  private registerStateChangeListener() {
    this.$transitions.onStart({}, (trans) => {
      const isNestedState = trans.to().name.indexOf('.') > -1;

      if(isNestedState) {
        const parentStateNameOfDestinationState = trans.to().name.split('.').shift();
        const parentStateNameOfCurrentState = trans.from().name.split('.').shift();

        if(parentStateNameOfDestinationState === parentStateNameOfCurrentState) {
          return;
        }
      }

      this.breadcrumbService.resetBreadcrumbs();
    });
  }
}